import axiosHttp from "services/axiosHttp";
const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const fetchPettyCashSummation = createAsyncThunk("fetchPettyCashSummation", async ({ floatId, categoryId }, { rejectWithValue }) => {
	const params = new URLSearchParams({
		float_id: floatId ?? "",
		category_id: categoryId ?? "",
	});

	try {
		const response = await axiosHttp.get(`petty-cash/summation?${params}`);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const PettyCashSummationSlice = createSlice({
	name: "PettyCashSummationSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPettyCashSummationState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashSummation.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.error = null;
		});

		builder.addCase(fetchPettyCashSummation.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchPettyCashSummation.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload || action.error;
			state.data = null;
		});
	},
});

export const { resetPettyCashSummationState } = PettyCashSummationSlice.actions;
export default PettyCashSummationSlice.reducer;
